import TableCell from '@material-ui/core/TableCell/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow/TableRow';
import {Result, TableWorker} from 'packages/common-types/schema-types';
import StyledButton from 'packages/common-ui/StyledButton';
import {retrieveMemberNames} from 'packages/common-utils/helpers';
import {ROUND_HEADERS} from 'packages/constants/table-constants';
import ModifyRoundData from 'packages/dialogs/ModifyRoundData';
import useAppSelector from 'packages/hooks/use-app-selector';
import {useModal} from 'packages/hooks/use-modal';
import useTablePagination from 'packages/hooks/use-table-pagination';
import BaseTable from 'packages/tables/BaseTable';
import {useEffect, useState} from 'react';
import {
  selectGeneratedRound,
  selectRoundMetadata,
  selectSelectedRound,
} from 'redux/features/round-slice';
import {v4 as uuidv4} from 'uuid';
import Select from 'react-select';

type Props = {
  previousRound?: Result[];
  tournamentId: string;
};

const CurrentRound = (props: Props) => {
  const {previousRound, tournamentId} = props;
  const generatedRound = useAppSelector(selectGeneratedRound);
  const selectedRound = useAppSelector(selectSelectedRound);
  const {currentRound} = useAppSelector(selectRoundMetadata);
  const {toggle, modalOpen} = useModal();
  const [tableToModify, setTableToModify] = useState<Result | null>(null);
  const [tableToSet, setTableToSet] = useState<TableWorker | null>(null);
  const [disableEdit, setDisableEdit] = useState(true);
  const [value, setValue] = useState(-1);
  const {onChangePage, onChangeRowsPerPage, page, rowsPerPage} =
    useTablePagination();

  let options;
  if (!previousRound) {
    options = [
      {
        value: -1,
        label: 'Sin filtros',
      },
    ].concat(
      generatedRound?.tables.map(({tableNumber}) => {
        return {
          value: tableNumber,
          label: `# Mesa ${tableNumber + 1}`,
        };
      })
    );
  } else {
    options = [
      {
        value: -1,
        label: 'Sin filtros',
      },
    ].concat(
      previousRound?.map(({tableNumber}) => {
        return {
          value: tableNumber,
          label: `# Mesa ${tableNumber + 1}`,
        };
      })
    );
  }

  // Current Round --> Ronda Actual
  useEffect(() => {
    if (previousRound && currentRound - (selectedRound.value + 1) <= 2) {
      setDisableEdit(false); // Ya no  puedo editar
    } else {
      setDisableEdit(true); // Puedo editar.
    }
  }, [currentRound, selectedRound.value, previousRound]);

  const handleEditData = (result?: Result, workerResponse?: TableWorker) => {
    if (!result) {
      setTableToSet(workerResponse);
    } else if (!disableEdit) {
      setTableToModify(result);
    }
    toggle();
  };

  const renderTableData = () => {
    const tables = generatedRound?.tables;
    let resultRenderTable;
    if (previousRound?.length) {
      resultRenderTable = [...previousRound]
        ?.sort((a, b) => a.tableNumber - b.tableNumber)
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((result) => {
          const {tableNumber, competitorOne, competitorTwo} = result;
          return (
            <TableRow key={uuidv4()}>
              <TableCell component="th" scope="row">
                {tableNumber + 1}
              </TableCell>
              <TableCell align="right">{competitorOne.name}</TableCell>
              <TableCell align="right">{competitorOne.result}</TableCell>
              <TableCell align="right">{competitorTwo.name}</TableCell>
              <TableCell align="right">{competitorTwo.result}</TableCell>
              <TableCell align="right">
                <StyledButton
                  size="medium"
                  disabled={disableEdit}
                  onClick={() => handleEditData(result)}
                  color="primary"
                >
                  Editar
                </StyledButton>
              </TableCell>
            </TableRow>
          );
        });
      if (value !== -1) {
        return resultRenderTable[value];
      }
      return resultRenderTable;
    }
    if (tables) {
      resultRenderTable = [...tables]
        ?.sort((a, b) => a.tableNumber - b.tableNumber)
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((workerResponse) => {
          const {competitorOne, competitorTwo, tableNumber, result} =
            workerResponse;

          const playerANames = retrieveMemberNames(competitorOne);
          const playerBNames = retrieveMemberNames(competitorTwo);

          return (
            <TableRow key={uuidv4()}>
              <TableCell component="th" scope="row">
                {tableNumber + 1}
              </TableCell>
              <TableCell align="right">{playerANames}</TableCell>
              <TableCell align="right">{result.competitorOne}</TableCell>
              <TableCell align="right">{playerBNames}</TableCell>
              <TableCell align="right">{result.competitorTwo}</TableCell>
              <TableCell align="right">
                <StyledButton
                  size="medium"
                  onClick={() => handleEditData(undefined, workerResponse)}
                  color="primary"
                >
                  Editar
                </StyledButton>
              </TableCell>
            </TableRow>
          );
        });
      if (value !== -1) {
        return resultRenderTable[value];
      }
      return resultRenderTable;
    }
    return [];
  };
  return (
    <>
      <ModifyRoundData
        workerResult={tableToSet}
        table={tableToModify}
        selectedRound={selectedRound.value}
        tournamentId={tournamentId}
        toggle={toggle}
        modalOpen={modalOpen}
      />
      <Select
        options={options}
        onChange={(val: any) => {
          setValue(val.value);
        }}
      />
      <BaseTable headers={ROUND_HEADERS}>{renderTableData()}</BaseTable>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={previousRound?.length || generatedRound?.tables.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </>
  );
};

CurrentRound.defaultProps = {
  previousRound: null,
};

export default CurrentRound;
